<pp-checkbox
  [ppDisabled]="ppReadOnly"
  [ppChecked]="value"
  (ppOnValueChange)="updateField()"
></pp-checkbox>

@if (!ppReadOnly && !ppUpdating) {
  <button class="pointCF__clear" (click)="clearCustomField()">&#xd7;</button>
}
